module.exports = __webpack_public_path__ + "static/img/bandan.11b0311.png";


//////////////////
// WEBPACK FOOTER
// ./static/bandan.png
// module id = oEFa
// module chunks = 1